import React, { FunctionComponent } from 'react';
import { Box } from '@rebass/emotion';
import {
  Wrapper,
  TextPlaceholder,
  ImagePlaceholder,
  Bottom,
  BottomEl,
} from './ProductPlaceholders.styles';

export const ProductPlaceholder: FunctionComponent = () => (
  <Wrapper>
    <ImagePlaceholder mb={4} />
    <TextPlaceholder width="30%" pb="6%" mb={3} />
    <TextPlaceholder width="60%" pb="4%" mb={2} />
    <TextPlaceholder width="80%" pb="4%" mb={2} />
    <TextPlaceholder width="60%" pb="4%" mb={4} />
    <Bottom mt={4}>
      <BottomEl>
        <TextPlaceholder width={1} pb="16%" />
      </BottomEl>
      <Box width="0.8%" />
      <BottomEl>
        <TextPlaceholder width={1} pb="16%" />
      </BottomEl>
    </Bottom>
  </Wrapper>
);

export default ProductPlaceholder;
